import { lazy } from "react";
// project import
import Loadable from "../../components/Loadable";
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| API CONTROLLER ||============================== //

// render - api_controller
const ApiController = Loadable(
  lazy(() => import("../../pages/api-controller/ApiControllerPage"))
);

const api_controller = {
  path: "api-services",
  element: (
    // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
    <ApiController />
    // </RequireAuthorizedAccess>
  ),
};

export default api_controller;
